import { createFileRoute, retainSearchParams } from '@tanstack/react-router';

import { type GlobalSelection, parseValidDateRange } from '~/lib/useGlobalFilter';

export interface PraetorCaseFeedSearchParams {
	type?: 'violation' | 'all';
	start?: string;
	end?: string;
}

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases/v2')({
	validateSearch: (search): PraetorCaseFeedSearchParams => {
		const dateRange = parseValidDateRange(search.start, search.end);

		return {
			type: (search.type as PraetorCaseFeedSearchParams['type']) ?? 'all',
			...dateRange
		};
	},
	search: {
		middlewares: [
			retainSearchParams<GlobalSelection & PraetorCaseFeedSearchParams>(['type', 'start', 'end'])
		]
	},
	beforeLoad: () => ({
		getTitle: 'Cases'
	})
});
